<template>
  <div>
    <div class="fw-bold">現在配車中の顧客よりメッセージがありました。</div>
    <spacer :y="2"/>
    <div>
      <p class="fs-5" v-html="parseNewlinesToBr(notice.data.text)"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';
import Spacer from '../../parts/Spacer.vue';

export default {
  name: 'receive-template-message',
  mixins: [cf],
  components: {
    Spacer,
  },
  data() {
    return {
      flag: {
        isLoading: false,
      },
    };
  },
  computed: {
    ...mapState(['notice']),
  },
};
</script>
